import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { PublicUserRole } from '../types/user';

export default function SignUp(): React.JSX.Element {
  const { register, isAuthenticated, isLoading, error } = useAuth();
  if (!isLoading && isAuthenticated) return <Navigate to="/dashboard" replace />;

  const start = (role: PublicUserRole) => void register(role).catch(() => undefined);

  return (
    <main className="mx-auto max-w-lg px-6 py-16">
      <div className="rounded-xl border border-slate-200 bg-white p-8 shadow-lg">
        <h1 className="text-center text-2xl font-bold text-mcc-darkest">Create an account</h1>
        <p className="mt-2 text-center text-sm text-slate-600">Choose the account that fits you.</p>
        {error && <p className="mt-4 text-center text-sm text-red-700">{error}</p>}
        <div className="mt-7 grid gap-3 sm:grid-cols-2">
          <button
            type="button"
            onClick={() => start('client')}
            className="rounded-lg border border-slate-300 p-5 text-left hover:border-mcc-neutral"
          >
            <span className="block font-semibold text-mcc-darkest">Client or family</span>
            <span className="mt-1 block text-sm text-slate-600">Find and manage care.</span>
          </button>
          <button
            type="button"
            onClick={() => start('caregiver')}
            className="rounded-lg border border-slate-300 p-5 text-left hover:border-mcc-neutral"
          >
            <span className="block font-semibold text-mcc-darkest">Caregiver</span>
            <span className="mt-1 block text-sm text-slate-600">Apply to provide care.</span>
          </button>
        </div>
        <p className="mt-6 text-center text-sm text-slate-600">
          Already registered? <Link className="font-semibold text-mcc-neutral" to="/login">Sign in</Link>
        </p>
      </div>
    </main>
  );
}
